import {InsightsTabState} from './insightsTab.types';

const insightsTabInitialState: InsightsTabState = {
  measuredPeriod: {
    activeSince: '',
    timezone: '',
    timezoneOptions: [],
  },
  availableMetricsWithTotals: [],
  availableDimensions: [],
  dashboards: [],
  widgets: [],
  availableFilters: [],
};

export {insightsTabInitialState};
